import React from "react";
import OnboardingFormWrapper from "../Onboarding/OnboardingFormWrapper";
import EntityInfo from "../Tpas/EntityInfo";

const NoAccessPage = ({ pending_registrations, logout_path }) => {
  const actionButtons = (
    <>
      <div className="onboarding__footernote">
        <div>Need Help? Contact Us</div>
        <div className="onboarding__footernote__contact">support@340besp.com</div>
      </div>
      <a href={logout_path} style={{ flexGrow: 0.5 }}>
        <button className="button button--blue" style={{ width: "100%" }}>
          Log Out
        </button>
      </a>
    </>
  );

  if (pending_registrations?.length) {
    return (
      <OnboardingFormWrapper title="Pending Covered Entity Access" actionButtons={actionButtons}>
        <p className="mb--24">
          340B ESP Support is working on verifying your entity access to the following covered
          entities:
        </p>
        <div className="mb--24 flex flex-column gap--16">
          {pending_registrations.map((registration, index) => (
            <React.Fragment key={registration.id_340b}>
              {index > 0 && <div className="line-divider" />}
              <EntityInfo id_340b={registration.id_340b} name={registration.entity_name} nowrap />
            </React.Fragment>
          ))}
        </div>
        <p>You will be contacted by Support on the next business day.</p>
      </OnboardingFormWrapper>
    );
  }

  return (
    <OnboardingFormWrapper title="No Covered Entity Access" actionButtons={actionButtons}>
      <p>You do not currently have access to any covered entities.</p>
      <p>
        Please contact your entity administrator or reach out to{" "}
        <a href="mailto:support@340besp.com">support@340besp.com</a> for assistance.
      </p>
    </OnboardingFormWrapper>
  );
};

export default NoAccessPage;
